import { Box } from '@mui/system';
import { useViewport } from 'hooks/useViewport';
import { CustomTab, CustomTabList } from './styles';

interface ICustomTabs {
  tabs: { label: string; value: string; width: string }[];
  handleChange?: (event: React.SyntheticEvent, newValue: string) => void;
  value: string | number;
}

export const CustomTabs = ({ tabs, value, handleChange }: ICustomTabs) => {
  const { isMedium } = useViewport();

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: 800, width: '100%' }}>
      <CustomTabList
        value={value}
        onChange={handleChange}
        centered
        {...(isMedium && { variant: 'scrollable', centered: false, scrollButtons: false })}
      >
        {tabs.map(({ label, value, width }) => (
          <CustomTab key={value} label={label} value={value} $tabWidth={width} />
        ))}
      </CustomTabList>
    </Box>
  );
};
